import EventEmitter from 'events';

/**
 * @param {HTMLSelectElement} el
 */
function getSelectQuantity(el) {
  return parseInt(el.value || 0, 10);
}

class PricetypeSelector extends EventEmitter {
  /**
   * @param {HTMLElement} el
   * @param {string} zoneId
   */
  constructor(el, zoneId) {
    super();
    this.bindMethods();

    this.el = el;
    this.zoneId = zoneId;

    /** @type {Map<number, HTMLSelectElement>} */
    this.selectMap = new Map();

    const selects = Array.from(this.el.querySelectorAll('.tn-ticket-selector__pricetype-select'));

    if (selects.length) {
      this.maxQuantity = selects[0].options.length - 1;

      selects.forEach((select) => {
        const pricetypeId = parseInt(select.dataset.pricetypeId, 10);

        select.addEventListener('change', this.onSelectChange);

        this.selectMap.set(pricetypeId, select);
      });

      this.updateSelectsForMax();
    }
  }

  bindMethods() {
    this.onSelectChange = this.onSelectChange.bind(this);
  }

  hasPricetype(pricetypeId) {
    return this.selectMap.has(parseInt(pricetypeId, 10));
  }

  getMaxQuantity() {
    return this.maxQuantity;
  }

  /**
   * @returns {Array.<{pricetypeId: number, quantity: number}>}
   */
  getAllPricetypeQuantities() {
    const data = [];

    this.selectMap.forEach((select, pricetypeId) => {
      const quantity = getSelectQuantity(select);

      data.push({
        pricetypeId,
        quantity,
      });
    });

    return data;
  }

  /**
   * @param {number} pricetypeId
   * @param {number} quantity
   */
  setSelectedQuantityForPricetype(pricetypeId, quantity) {
    const select = this.selectMap.get(parseInt(pricetypeId, 10));
    select.value = quantity;
  }

  updateSelectsForMax() {
    const { maxQuantity } = this;
    const totalQuantitySelected = this.getTotalQuantitySelected();
    const totalRemaining = maxQuantity - totalQuantitySelected;

    // console.log({ totalRemaining, totalQuantitySelected, maxQuantity });

    Array.from(this.selectMap.values())
      .forEach((select) => {
        const quantity = getSelectQuantity(select);
        const maxOption = totalRemaining + quantity;

        // console.log({ quantity, maxOption });

        if (maxOption <= 0) {
          select.setAttribute('disabled', 1);
        } else {
          select.removeAttribute('disabled');
        }

        const optionsToRemove = [];

        for (let i = 0; i <= maxQuantity; i += 1) {
          const option = select.options[i];

          if (option) {
            if (i > maxOption) {
              optionsToRemove.push(option);
            }
          } else {
            if (i <= maxOption) {
              const newOption = document.createElement('option');
              newOption.text = i;
              newOption.value = i;
              newOption.selected = quantity === i;
              select.appendChild(newOption);
            }
          }
        }

        optionsToRemove.forEach(option => select.removeChild(option));
      });
  }

  onSelectChange() {
    this.updateSelectsForMax();
    this.emit('change');
  }

  getTotalQuantitySelected() {
    return Array.from(this.selectMap.values())
      .reduce((sum, select) => {
        const value = getSelectQuantity(select);
        return sum + value;
      }, 0);
  }

  show() {
    this.el.style.display = '';
  }

  hide() {
    this.el.style.display = 'none';
  }

  destroy() {
    this.removeAllListeners();

    this.selectMap.forEach((select) => {
      select.removeEventListener('change', this.onSelectChange);
    });
  }
}

export default PricetypeSelector;



// WEBPACK FOOTER //
// ./V7/events/detail/PricetypeSelector.js